<script setup>
import FooterNav from '@/components/layout/Footer/FooterMain/FooterNav.vue';
import FooterContacts from '@/components/layout/Footer/FooterMain/FooterContacts.vue';
import SocialsList from '@/components/SocialsList.vue';
defineProps({
  nav: {
    type: Array,
    default: () => [],
  },
  additionalLinks: {
    type: Array,
    default: () => [],
  },
  socials: {
    type: Object,
    default: () => {},
  },
  contacts: {
    type: Object,
    default: () => {},
  },
});
</script>

<template>
  <div class="footer__main">
    <div class="footer__main-top">
      <FooterNav
        :nav="nav"
        :additional-links="additionalLinks"
        class="footer__nav"
      />
      <SocialsList
        v-if="socials && socials.length > 0"
        :data="socials"
        :view="'light'"
        class="footer__socials"
      />
    </div>
    <FooterContacts :data="contacts" class="footer__contacts" />
  </div>
</template>
<style scoped lang="scss">
.footer {
  &__main {
    align-items: start;
    display: grid;
    gap: 32px;
    grid-template-columns: 1fr;
    @include media-breakpoint-up(sm) {
      gap: 64px;
    }
    @include media-breakpoint-up(md) {
      gap: 0px;
      grid-template-columns: 8.1fr 3.9fr;
    }
    &-top {
      display: flex;
      flex-direction: column;
      gap: 20px;
      @include media-breakpoint-up(sm) {
        gap: 52px;
      }
      @include media-breakpoint-up(md) {
        gap: 0;
      }
    }
  }
}
</style>
